import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCourseAccess } from '@/hooks/useCourseAccess';
import { AppLayout } from '@/components/layout/AppLayout';
import {} from 'lucide-react';
import { LoadingSpinner } from '@/components/LoadingSpinner';

interface PracticeAccessGuardProps {
  children: React.ReactNode;
}

/**
 * Wraps practice pages to check course access via the task's course_id.
 * Redirects to course page if user doesn't have access.
 */
export const PracticeAccessGuard = ({ children }: PracticeAccessGuardProps) => {
  const { taskId } = useParams();
  const navigate = useNavigate();
  const { hasAccess, loading, courseId } = useCourseAccess({ taskId });

  useEffect(() => {
    if (!loading && hasAccess === false) {
      if (courseId) {
        navigate(`/courses/${courseId}`, { replace: true });
      } else {
        navigate('/courses', { replace: true });
      }
    }
  }, [loading, hasAccess, courseId, navigate]);

  if (loading) {
    return (
      <AppLayout>
        <LoadingSpinner />
      </AppLayout>
    );
  }

  if (hasAccess === false) return null;

  return <>{children}</>;
};
